import dataApplicationsContext from "../../../context/dataApplicationsContext"
import { useContext, useEffect, useRef, useState } from 'react';
import UserGoBack from "../../user/UserGoBack";
import RightPartContent from "../RightPartContent";
import ArticleUtile from "../ArticleUtile";
import TagsAnchorContainer from "../TagsAnchorContainer";
import UserOnglet from "../../user/UserOnglet";
import { useTopic } from "../../../hooks/useTopic";

const HelpTopicCodePromo = () => {
  const { windowWidth, setOngletPaiementActif } = useContext(dataApplicationsContext);

  const [ongletActif, setOngletActif] = useState('');
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const { topic, isLoading, LoadingComponent } = useTopic();
  if (isLoading) return <LoadingComponent />;

  const isSmallDevise = windowWidth < 900;  

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: "Rechercher et s'inscrire", link: '/topics/rechercher'},
    { label: "S'inscrire des compétitions", link: '/topics/rechercher/sincrire-competition-index'},
    { label: topic.title, link: topic.link},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo={topic.slug} titleClass='mb-0 w-help-title'
      />
      <div className="help-content-container mt-16">
        <div className="help-content-flex mb-80">
          <div className="help-left-part">
            <p className="help-text">
              Bien joué ! Vous avez trouvé un code promo pour réduire le coût de votre inscription à la compétition. Voici comment l'appliquer.
            </p>
            <div className="article-container mt-40">
              <p className="help-title-part">{topic.subtitles[0]}</p>
              <p className="help-text">
                Au moment de l'étape 3 sur 3, lors de votre<a target='_blank' className="link" href={`/topics/inscription/31`}>inscription</a>à une compétition :
              </p>
              <UserOnglet
                onglets={[{label: 'Ordinateur de bureau', id: 1}, {label: 'Navigateur mobile', id: 2}]} 
                ongletActif={ongletActif} setOngletActif={setOngletActif}
              />
              {ongletActif.id === 1
                ? <div className="mt-32">
                    <p className="help-subtitle-part">Appliquer mon code promo sur ordinateur</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Sur la droite de la page, dans la zone qui récapitule le détail de votre commande. Cliquez sur <strong>Un code promo ?</strong>
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Dans le champs, saisissez alors votre code promo, puis cliquez sur <strong>Appliquer</strong></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Si votre code est valide, le montant de votre commande sera automatiquement mis à jour.</p></li>
                    </ol>
                  </div>
                : <div className="mt-32">
                    <p className="help-subtitle-part">Appliquer mon code promo sur navigateur mobile</p>
                    <ol className="mb-6">
                      <li className="pl-8 mb-8">
                        <p className="help-text">
                          Dans la section <strong>Détails du prix,</strong> appuyez sur <strong>Un code promo ?</strong>
                        </p>
                      </li>
                      <li className="pl-8 mb-8">
                        <p className="help-text">Dans le champs, saisissez alors votre code promo, puis appuyez sur <strong>Appliquer</strong></p>
                      </li>
                      <li className="pl-8 mb-8"><p className="help-text">Si votre code est valide, le montant de votre commande sera automatiquement mis à jour.</p></li>
                    </ol>
                  </div>
              }
            </div>
            <ArticleUtile id_topic={topic.id_topic}/>
          </div>
          <RightPartContent />
        </div>
      </div>
    </div>
  )
}

export default HelpTopicCodePromo